/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeviceRegistered,
  DeviceRemoveRequest,
  DeviceRemoved,
  DeviceTokenRequest,
  NotificationLog,
  NotificationSettings,
  NotificationsLogsListParams,
  NotificationsSettingsListParams,
  PaginatedNotificationLogList,
  PaginatedNotificationSettingsList,
  PatchedNotificationSettingsRequest
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * The app sends its Expo push token after sign-in (reminders arrive free on the phone).
 */
export type notificationsDevicesCreateResponse201 = {
  data: DeviceRegistered
  status: 201
}
    
export type notificationsDevicesCreateResponseSuccess = (notificationsDevicesCreateResponse201) & {
  headers: Headers;
};
;

export type notificationsDevicesCreateResponse = (notificationsDevicesCreateResponseSuccess)

export const getNotificationsDevicesCreateUrl = () => {


  

  return `/api/v1/notifications/devices/`
}

export const notificationsDevicesCreate = async (deviceTokenRequest: DeviceTokenRequest, options?: RequestInit): Promise<notificationsDevicesCreateResponse> => {
  
  return apiFetch<notificationsDevicesCreateResponse>(getNotificationsDevicesCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceTokenRequest,)
  }
);}




export const getNotificationsDevicesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsDevicesCreate>>, TError,{data: DeviceTokenRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsDevicesCreate>>, TError,{data: DeviceTokenRequest}, TContext> => {

const mutationKey = ['notificationsDevicesCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsDevicesCreate>>, {data: DeviceTokenRequest}> = (props) => {
          const {data} = props ?? {};

          return  notificationsDevicesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationsDevicesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsDevicesCreate>>>
    export type NotificationsDevicesCreateMutationBody = DeviceTokenRequest
    export type NotificationsDevicesCreateMutationError = unknown

    export const useNotificationsDevicesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsDevicesCreate>>, TError,{data: DeviceTokenRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsDevicesCreate>>,
        TError,
        {data: DeviceTokenRequest},
        TContext
      > => {

      const mutationOptions = getNotificationsDevicesCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * At sign-out the app removes its token: nothing reaches a phone after the person left.
 */
export type notificationsDevicesRemoveCreateResponse200 = {
  data: DeviceRemoved
  status: 200
}
    
export type notificationsDevicesRemoveCreateResponseSuccess = (notificationsDevicesRemoveCreateResponse200) & {
  headers: Headers;
};
;

export type notificationsDevicesRemoveCreateResponse = (notificationsDevicesRemoveCreateResponseSuccess)

export const getNotificationsDevicesRemoveCreateUrl = () => {


  

  return `/api/v1/notifications/devices/remove/`
}

export const notificationsDevicesRemoveCreate = async (deviceRemoveRequest: DeviceRemoveRequest, options?: RequestInit): Promise<notificationsDevicesRemoveCreateResponse> => {
  
  return apiFetch<notificationsDevicesRemoveCreateResponse>(getNotificationsDevicesRemoveCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      deviceRemoveRequest,)
  }
);}




export const getNotificationsDevicesRemoveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsDevicesRemoveCreate>>, TError,{data: DeviceRemoveRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsDevicesRemoveCreate>>, TError,{data: DeviceRemoveRequest}, TContext> => {

const mutationKey = ['notificationsDevicesRemoveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsDevicesRemoveCreate>>, {data: DeviceRemoveRequest}> = (props) => {
          const {data} = props ?? {};

          return  notificationsDevicesRemoveCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationsDevicesRemoveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsDevicesRemoveCreate>>>
    export type NotificationsDevicesRemoveCreateMutationBody = DeviceRemoveRequest
    export type NotificationsDevicesRemoveCreateMutationError = unknown

    export const useNotificationsDevicesRemoveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsDevicesRemoveCreate>>, TError,{data: DeviceRemoveRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsDevicesRemoveCreate>>,
        TError,
        {data: DeviceRemoveRequest},
        TContext
      > => {

      const mutationOptions = getNotificationsDevicesRemoveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type notificationsLogsListResponse200 = {
  data: PaginatedNotificationLogList
  status: 200
}
    
export type notificationsLogsListResponseSuccess = (notificationsLogsListResponse200) & {
  headers: Headers;
};
;

export type notificationsLogsListResponse = (notificationsLogsListResponseSuccess)

export const getNotificationsLogsListUrl = (params?: NotificationsLogsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/notifications/logs/?${stringifiedParams}` : `/api/v1/notifications/logs/`
}

export const notificationsLogsList = async (params?: NotificationsLogsListParams, options?: RequestInit): Promise<notificationsLogsListResponse> => {
  
  return apiFetch<notificationsLogsListResponse>(getNotificationsLogsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getNotificationsLogsListQueryKey = (params?: NotificationsLogsListParams,) => {
    return [
    `/api/v1/notifications/logs/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getNotificationsLogsListQueryOptions = <TData = Awaited<ReturnType<typeof notificationsLogsList>>, TError = unknown>(params?: NotificationsLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsLogsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsLogsList>>> = ({ signal }) => notificationsLogsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsLogsListQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsLogsList>>>
export type NotificationsLogsListQueryError = unknown


export function useNotificationsLogsList<TData = Awaited<ReturnType<typeof notificationsLogsList>>, TError = unknown>(
 params: undefined |  NotificationsLogsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsLogsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsLogsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsLogsList<TData = Awaited<ReturnType<typeof notificationsLogsList>>, TError = unknown>(
 params?: NotificationsLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsLogsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsLogsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsLogsList<TData = Awaited<ReturnType<typeof notificationsLogsList>>, TError = unknown>(
 params?: NotificationsLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsLogsList<TData = Awaited<ReturnType<typeof notificationsLogsList>>, TError = unknown>(
 params?: NotificationsLogsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsLogsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type notificationsLogsRetrieveResponse200 = {
  data: NotificationLog
  status: 200
}
    
export type notificationsLogsRetrieveResponseSuccess = (notificationsLogsRetrieveResponse200) & {
  headers: Headers;
};
;

export type notificationsLogsRetrieveResponse = (notificationsLogsRetrieveResponseSuccess)

export const getNotificationsLogsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/notifications/logs/${id}/`
}

export const notificationsLogsRetrieve = async (id: string, options?: RequestInit): Promise<notificationsLogsRetrieveResponse> => {
  
  return apiFetch<notificationsLogsRetrieveResponse>(getNotificationsLogsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getNotificationsLogsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/notifications/logs/${id}/`
    ] as const;
    }

    
export const getNotificationsLogsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsLogsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsLogsRetrieve>>> = ({ signal }) => notificationsLogsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsLogsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsLogsRetrieve>>>
export type NotificationsLogsRetrieveQueryError = unknown


export function useNotificationsLogsRetrieve<TData = Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsLogsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notificationsLogsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsLogsRetrieve<TData = Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsLogsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notificationsLogsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsLogsRetrieve<TData = Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsLogsRetrieve<TData = Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsLogsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsLogsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type notificationsSettingsListResponse200 = {
  data: PaginatedNotificationSettingsList
  status: 200
}
    
export type notificationsSettingsListResponseSuccess = (notificationsSettingsListResponse200) & {
  headers: Headers;
};
;

export type notificationsSettingsListResponse = (notificationsSettingsListResponseSuccess)

export const getNotificationsSettingsListUrl = (params?: NotificationsSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/notifications/settings/?${stringifiedParams}` : `/api/v1/notifications/settings/`
}

export const notificationsSettingsList = async (params?: NotificationsSettingsListParams, options?: RequestInit): Promise<notificationsSettingsListResponse> => {
  
  return apiFetch<notificationsSettingsListResponse>(getNotificationsSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getNotificationsSettingsListQueryKey = (params?: NotificationsSettingsListParams,) => {
    return [
    `/api/v1/notifications/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getNotificationsSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof notificationsSettingsList>>, TError = unknown>(params?: NotificationsSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsSettingsList>>> = ({ signal }) => notificationsSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsSettingsList>>>
export type NotificationsSettingsListQueryError = unknown


export function useNotificationsSettingsList<TData = Awaited<ReturnType<typeof notificationsSettingsList>>, TError = unknown>(
 params: undefined |  NotificationsSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsSettingsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsSettingsList<TData = Awaited<ReturnType<typeof notificationsSettingsList>>, TError = unknown>(
 params?: NotificationsSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsSettingsList>>,
          TError,
          Awaited<ReturnType<typeof notificationsSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsSettingsList<TData = Awaited<ReturnType<typeof notificationsSettingsList>>, TError = unknown>(
 params?: NotificationsSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsSettingsList<TData = Awaited<ReturnType<typeof notificationsSettingsList>>, TError = unknown>(
 params?: NotificationsSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type notificationsSettingsRetrieveResponse200 = {
  data: NotificationSettings
  status: 200
}
    
export type notificationsSettingsRetrieveResponseSuccess = (notificationsSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type notificationsSettingsRetrieveResponse = (notificationsSettingsRetrieveResponseSuccess)

export const getNotificationsSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/notifications/settings/${id}/`
}

export const notificationsSettingsRetrieve = async (id: string, options?: RequestInit): Promise<notificationsSettingsRetrieveResponse> => {
  
  return apiFetch<notificationsSettingsRetrieveResponse>(getNotificationsSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getNotificationsSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/notifications/settings/${id}/`
    ] as const;
    }

    
export const getNotificationsSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationsSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>> = ({ signal }) => notificationsSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationsSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>>
export type NotificationsSettingsRetrieveQueryError = unknown


export function useNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notificationsSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationsSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof notificationsSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationsSettingsRetrieve<TData = Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationsSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationsSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type notificationsSettingsPartialUpdateResponse200 = {
  data: NotificationSettings
  status: 200
}
    
export type notificationsSettingsPartialUpdateResponseSuccess = (notificationsSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type notificationsSettingsPartialUpdateResponse = (notificationsSettingsPartialUpdateResponseSuccess)

export const getNotificationsSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/notifications/settings/${id}/`
}

export const notificationsSettingsPartialUpdate = async (id: string,
    patchedNotificationSettingsRequest: PatchedNotificationSettingsRequest, options?: RequestInit): Promise<notificationsSettingsPartialUpdateResponse> => {
  
  return apiFetch<notificationsSettingsPartialUpdateResponse>(getNotificationsSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedNotificationSettingsRequest,)
  }
);}




export const getNotificationsSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsSettingsPartialUpdate>>, TError,{id: string;data: PatchedNotificationSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationsSettingsPartialUpdate>>, TError,{id: string;data: PatchedNotificationSettingsRequest}, TContext> => {

const mutationKey = ['notificationsSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationsSettingsPartialUpdate>>, {id: string;data: PatchedNotificationSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  notificationsSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationsSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof notificationsSettingsPartialUpdate>>>
    export type NotificationsSettingsPartialUpdateMutationBody = PatchedNotificationSettingsRequest
    export type NotificationsSettingsPartialUpdateMutationError = unknown

    export const useNotificationsSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationsSettingsPartialUpdate>>, TError,{id: string;data: PatchedNotificationSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationsSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedNotificationSettingsRequest},
        TContext
      > => {

      const mutationOptions = getNotificationsSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    